import JobPost from "../../components/employeer/jos-post";

const JobPostEmployeerPage = () => {
  return <JobPost />;
};

export default JobPostEmployeerPage;
